module.exports = __webpack_public_path__ + "img/23.d861ec88.jpg";